import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { FeedstockService } from '../../../services/feedstockservice';
import { FeedStockLoadDocumentResponse, ViewDocumentsDialogData } from '../../../interfaces/pricematrixmodel';
import { ConfirmationDialogData, ConfirmationDialogComponent } from '../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { MatCardContent, MatCardModule } from "@angular/material/card";
import { DragDropModule } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-view-documents',
  imports: [
    CommonModule,
    MatDialogModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatCardContent,
    MatCardModule,
    DragDropModule
],
  templateUrl: './view-documents.component.html',
  styleUrl: './view-documents.component.scss'
})
export class ViewDocumentsComponent implements OnInit {

  displayedColumns: string[] = [ 'actions', 'id', 'name', 'type'];
  documents: FeedStockLoadDocumentResponse[] = [];
  loadScheduleId: number;
  screenTypeId: number = 0;
  canShowGridActions: boolean = true;
  dialogTitle: string = '';

  constructor(
    public dialogRef: MatDialogRef<ViewDocumentsComponent>,
    private dialog:MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: ViewDocumentsDialogData,
    private feedstockService: FeedstockService
  ) {
    this.loadScheduleId = data.loadScheduleId;
    this.screenTypeId = data.screenTypeId;
    this.canShowGridActions = data.canShowGridActions;
    this.dialogTitle = data.name;

    console.log("view docs input", data);
  }

  ngOnInit(): void {
    this.getDocuments();
  }

  getDocuments(): void {    
    this.feedstockService.getDocuments(this.loadScheduleId, this.screenTypeId).subscribe({
      next: (data: FeedStockLoadDocumentResponse[]) => {
        console.log("fetched docs", data);
        this.documents = data;
      }
    });
  }

  onDownloadDocument(element: FeedStockLoadDocumentResponse): void {
    
    if (!element || !element.name || !element.blobID || element.docTypeId === undefined) {
      return;
    }

    this.feedstockService.downloadDocument(element).subscribe({
      next: (response: Blob) => {
        // Create a temporary URL to download the blob
        const downloadUrl = window.URL.createObjectURL(response);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = element.name ?? '';
        link.click();
        
        window.URL.revokeObjectURL(downloadUrl);
      }
    });

  }

  onViewDocument(document: FeedStockLoadDocumentResponse): void {
    const downloadUrl = `/FeedStock/DownloadDocument?fileName=${document.name}&blobId=${document.blobID}&docTypeId=${document.docTypeId}`;
    window.open(downloadUrl, '_blank');
  }

  onDeleteDocument(document: FeedStockLoadDocumentResponse): void {
    console.log("delete doc", document);
    const dialogData: ConfirmationDialogData = {
      title: 'Confirm Deletion',
      message: `Are you sure you want to delete document ${document.name}?`,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      confirmButtonColor: 'warn'
    };
    
    this.dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      panelClass: 'delete-confirmation-dialog',
      data: dialogData,
      disableClose: true
    }).afterClosed().subscribe(result => {
      if (result) {
        this.feedstockService.deleteDocument( `${document.name}`, `${document.blobID}`, document.docTypeId ?? 0).subscribe({
          next: () => {              
            this.getDocuments(); 
          }
        });
      }
    });
  }

  onClose(): void {
    if(this.documents.length == 0){
      this.dialogRef.close(true);
    }else{
      this.dialogRef.close(false);
    }
  }
}
